import React from 'react';
import FieldGenerico from '../componentes_generales/componentes_formulario/fields/fieldgenerico';
import FieldSelect from '../componentes_generales/componentes_formulario/fields/fieldselect/fieldselect';
import { Label } from '../componentes_generales/componentes_formulario/labels/';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerEdit} from '../componentes_generales/componentes_formulario/contenedores/';
import { Field, reduxForm , formValueSelector  } from 'redux-form';
import FieldBusqEspecifica from '../componentes_generales/componentes_formulario/fields/busqueda_especifica/fieldselectasync-busq-especif';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import { cargarCatalogos, cargarCatalogosGenericoAsyncInvertido } from '../../funciones_globales/catalogos';
import { cargar_AjustePlanPago, cargar_ValoresIniciales } from '../../actions/importaciones/act_impor03';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { connect } from 'react-redux';
import global_axios from '../../funciones_globales/interaccionapi';
import { getItemDatosSesion } from '../../funciones_globales/manejosesion';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm  } from '../../actions/generales/act_gen03';
import { validarFechaTransaccionSeleccionada } from '../../funciones_globales/utils';
import moment from 'moment';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import { formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

const validate = values => {
    const errors = {}
    if(!values.observacion ){
      errors.observacion = 'El campo es obligatorio';
    }
    return errors
}

class FormImport03 extends React.Component{
    constructor(props){
        super(props);
            this.state = {
                codigo_importacion: 0,
                tipo_ajuste: [{value: '1', label: 'NC'},{value: '2', label: 'ND'}],
                array_motivo: [],
                fechaProceso: null,
                //Grid PlanPago
                data_planpago_import: [],
                columnDefs_Planpago:[   
                                        {   header: "Tipo Fecha",
                                            field: "DESCRIPCION",
                                            width: 218,
                                            type: "string"                                                 
                                        },
                                        {   header: "Fecha de pago",
                                            field: "fechapago",
                                            width: 100,
                                            type: "fecha"                                                 
                                        },
                                        {   header: "Dias plazo",
                                            field: "DiasPlazo",
                                            width: 100,
                                            type: "num_entero"                                             
                                        },
                                        {   header: "Porcentaje",
                                            field: "porcentaje",
                                            width: 100,
                                            type: "num_entero"                                             
                                        },
                                        {   header: "Valor calculado",
                                            field: "valorcalculado",
                                            width: 120,
                                            type: "num_decimal"                                                
                                        },
                                        {   header: "Creditos",
                                            field: "ABONOCRE",
                                            width: 75,
                                            type: "num_decimal"                                                
                                        },
                                        {   header: "Debitos",
                                            field: "ABONODEB",
                                            width: 75,
                                            type: "num_decimal"                                                
                                        },
                                        {   header: "Saldo",
                                            field: "Saldo",
                                            width: 75,
                                            type: "num_decimal"                                                
                                        },
                                        {   header: "Valor ajuste",   //mbaquero 20240123
                                            field: "valor_restado",
                                            width: 98,
                                            type: "num_decimal_edit",
                                            editable: true                                               
                                        }
                                    ],
                gridOptions_PlanPago: {
                    context: {
                        componentParent: this
                    },
                    rowSelection: "single",
                    suppressRowClickSelection:true,
                    singleClickEdit: true,
                    enableColResize: true,
                    enableCellChangeFlash: true,
                    onCellValueChanged:((event)=>{
                    
                        switch (event.colDef.field){
                            case "valor_restado":
                            
                                if(isNaN(event.data.valor_restado)===true || event.data.valor_restado===""){                            
                                    event.data.valor_restado = 0
                                }else{
                                    var valor_editado = 0;
                                    var saldo = 0;
                                    valor_editado = parseFloat(event.data.valor_restado);
                                    saldo = parseFloat(event.data.Saldo);
                                    if( (Math.round(valor_editado * 100) / 100) > (Math.round(saldo * 100) / 100)){
                                        event.data.valor_restado = 0
                                    }else{
                                        event.data.valor_restado = valor_editado;
                                    }
                                }

                            break
                            default:
                            break
                        }
                        this.apiPlanPago.refreshCells();
                    })   
                },
                
                data_ajustes: [],
                columnDefs_Ajustes:[   
                                        {   header: "Codigo",
                                            field: "Codigo",
                                            width: 100,
                                            type: "string"                                                 
                                        },
                                        {   header: "Tipo",
                                            field: "Tipo",
                                            width: 100,
                                            type: "string"                                                 
                                        },
                                        {   header: "Motivo",
                                            field: "Motivo",
                                            width: 100,
                                            type: "string"                                             
                                        },
                                        {   header: "Observación",
                                            field: "Observacion",
                                            width: 390,
                                            type: "string"                                             
                                        },
                                        {   header: "Fecha",
                                            field: "Fecha",
                                            width: 100,
                                            type: "fecha"                                                
                                        },
                                        {   header: "Valor",
                                            field: "Valor",
                                            width: 75,
                                            type: "num_decimal"                                                
                                        },
                                        {   header: "",
                                            field: "eliminar",
                                            width: 75,
                                            type: "link_elim"                                                
                                        },
                                    ],
                gridOptions_Ajustes: {
                    context: {
                        componentParent: this
                    },

                },
            };
            
            this.onGridPlanPago = this.onGridPlanPago.bind(this);
            this.onGridAjusteImport = this.onGridAjusteImport.bind(this);
    }

    onGridPlanPago(params) {
        this.apiPlanPago = params.api;
        this.columnApiPlanPago = params.columnApi;
    }

    onGridAjusteImport(params) {
        this.apiAjusteImport = params.api;
        this.columnApiAjusteImport = params.columnApi;
    }

    //Busqueda
    getOptions_Importaciones(input, callback){
        if (input.toString().length >= 3 ){
            let cadena_busq = '?cadena_busq=' + input;
            cargarCatalogosGenericoAsyncInvertido('/importaciones', cadena_busq, callback)  
        }
    }

    getImportacion(){

        if (this.props.codigo_importacion === undefined){
            alert('Ud. no ha seleccionado una importación que desee editar.');
        }else{
            
            const codigo_import_editar = this.props.codigo_importacion.value

            Promise.all([this.props.cargar_Ajuste_PlanPago_a_Editar(codigo_import_editar)])
                .then(() => {
                    var arrayPlanPago = [];
                    this.props.detalle_plan_pago.forEach((DATA)=>{
                        var item = {};

                        item.DESCRIPCION = DATA.DESCRIPCION;
                        item.secuencia = DATA.secuencia;
                        item.fechapago = DATA.fechapago;
                        item.DiasPlazo = DATA.DiasPlazo;
                        item.porcentaje = DATA.porcentaje;
                        item.valorcalculado = DATA.valorcalculado;
                        item.ABONOCRE = DATA.ABONOCRE;
                        item.ABONODEB = DATA.ABONODEB;
                        item.Saldo = DATA.Saldo;
                        item.IdPPImportacion = DATA.IdPPImportacion;
                        item.valor_restado = 0;
                        arrayPlanPago.push(item);
                    })

                    this.setState(
                        { data_planpago_import: arrayPlanPago}
                    )
        
                    this.setState(
                        { data_ajustes: this.props.detalle_ajuste}
                    )
                    
                    this.setState(
                        { codigo_importacion: codigo_import_editar}
                    )
                })
                .catch(err => {
                    console.log(err);
                    alert(err)
            });
        }
    }

    submit(e){
        var data = {};
        var proceder = true;
        var errors = '';

        let fechaProceso = getFechaProcesoPorModulo('03');

        if(this.state.data_planpago_import.length >0){
            var valorTotal = 0;
            var arrayPlanPago = [];
            this.state.data_planpago_import.forEach((det, i)=>{

                if(parseFloat(det.valor_restado, 10)>0){
                    var item = {};

                    item.DESCRIPCION = det.DESCRIPCION;
                    item.secuencia = det.secuencia;
                    item.fechapago = det.fechapago;
                    item.DiasPlazo = det.DiasPlazo;
                    item.porcentaje = det.porcentaje;
                    item.valorcalculado = det.valorcalculado;
                    item.ABONOCRE = det.ABONOCRE;
                    item.ABONODEB = det.ABONODEB;
                    item.Saldo = det.Saldo;
                    item.IdPPImportacion = det.IdPPImportacion;
                    item.valor_restado = det.valor_restado;

                    arrayPlanPago.push(item);

                    valorTotal = valorTotal+parseFloat(det.valor_restado);
                }
            })

            data.plan_pago = arrayPlanPago;
            data.valorTotal = valorTotal

            if(data.plan_pago.length === 0){
                proceder = false;
                errors+='- Ingrese un valor a descontar donde exista saldo superior a 0\n'
            }
        }else{
            proceder = false;
            errors+='- No hay datos\n'
        }

        if(e.motivo===null && e.tipo_ajuste===null){
            proceder = false;
            errors+='- Seleccione ajuste o motivo antes de continuar\n'
        }

        // Validacion de fecha de proceso que se puede cambiar ------------------------------
        if (this.props.permiteCambioFProceso==='S'){
            let resultadoValidFProceso = validarFechaTransaccionSeleccionada(this.state.fechaProceso, moment(fechaProceso, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);
            if(resultadoValidFProceso.esValida===false){
                proceder = false;
                errors = errors + resultadoValidFProceso.msg+'\n'
                console.log("PROCESO FECHA PROCESO: ", resultadoValidFProceso)
            }
        }

        if(proceder === true){
            

            data.fecha = formatearFechaMoment_a_String(this.state.fechaProceso);
            data.motivo = e.motivo;
            data.observacion = e.observacion.toString().toUpperCase();
            data.tipo_ajuste = e.tipo_ajuste;
            data.usuario = getItemDatosSesion('usuario').toString();

            data.FechaProceso = formatearFechaMoment_a_String(this.state.fechaProceso);

            var last_import= this.state.codigo_importacion.toString();
            e.valor=valorTotal;
            
            let config_request = {
                method: 'POST',
                url: '/importaciones/' + this.state.codigo_importacion.toString() +'/ajusteplanpago',
                data
            }
            global_axios(config_request)
            .then((response)=>{                             
                alert('Ajuste ingresado correctamente') 
                Promise.all([this.props.cargar_Ajuste_PlanPago_a_Editar(last_import)])
                    .then(() => {
                        var arrayPlanPago = [];
                        this.props.detalle_plan_pago.forEach((DATA)=>{
                            var item = {};

                            item.DESCRIPCION = DATA.DESCRIPCION;
                            item.secuencia = DATA.secuencia;
                            item.fechapago = DATA.fechapago;
                            item.DiasPlazo = DATA.DiasPlazo;
                            item.porcentaje = DATA.porcentaje;
                            item.valorcalculado = DATA.valorcalculado;
                            item.ABONOCRE = DATA.ABONOCRE;
                            item.ABONODEB = DATA.ABONODEB;
                            item.Saldo = DATA.Saldo;
                            item.IdPPImportacion = DATA.IdPPImportacion;
                            item.valor_restado = 0;
                            arrayPlanPago.push(item);
                        })

                        this.setState({ data_planpago_import: arrayPlanPago})
                        this.setState({data_ajustes: this.props.detalle_ajuste})
                        this.setState({ codigo_importacion: last_import})
                    })
                    .catch(err => {
                        console.log(err);
                });
                            
            })        
            .catch((error)=>{
                if (error.response){
                    alert(error.response.data.msg);
                }
            })
        }else{
            alert(errors)
        }
    }

    methodFromParent(id, datos_fila) {        
        var mensaje = window.confirm("¿Desea eliminar el registro?"); 

        if (mensaje){
            this.eliminar(datos_fila ) 
        } 
    }

    eliminar(datos_fila){
        var e = {};
        e.localidad = '01';
        e.Codigo = datos_fila.Codigo;
        e.Importacion = this.state.codigo_importacion.toString();
        e.DataFila = datos_fila;
        e.Tipo = datos_fila.Tipo==='NC'?'NCI':'NDI';
        e.Usuario = getItemDatosSesion('usuario').toString();
        e.IdAuditoriaSW = this.props.IdRegAudit;

        var last_import= this.state.codigo_importacion.toString();

        let config_request = {
            method: 'PUT',
            url: '/importaciones/' + this.state.codigo_importacion.toString() +'/ajusteplanpago/'+ e.Codigo,
            data: e
        }

        global_axios(config_request)
        .then((response)=>{
            console.log("RESPUESTA: ", response)
            if(response){
                alert(response.data.msg);
                Promise.all([this.props.cargar_Ajuste_PlanPago_a_Editar(last_import)])
                    .then(() => {
                        var arrayPlanPago = [];
                        this.props.detalle_plan_pago.forEach((DATA)=>{
                            var item = {};

                            item.DESCRIPCION = DATA.DESCRIPCION;
                            item.secuencia = DATA.secuencia;
                            item.fechapago = DATA.fechapago;
                            item.DiasPlazo = DATA.DiasPlazo;
                            item.porcentaje = DATA.porcentaje;
                            item.valorcalculado = DATA.valorcalculado;
                            item.ABONOCRE = DATA.ABONOCRE;
                            item.ABONODEB = DATA.ABONODEB;
                            item.Saldo = DATA.Saldo;
                            item.IdPPImportacion = DATA.IdPPImportacion;
                            item.valor_restado = 0;
                            arrayPlanPago.push(item);
                        })

                        this.setState({ data_planpago_import: arrayPlanPago})
                        this.setState({ data_ajustes: this.props.detalle_ajuste})
                        this.setState({ codigo_importacion: last_import})
                })
            }else{
                alert('Error al eliminar');
            }
            
        }) 
        .catch(function(error){
            if (error.response){
               alert(error.response.data.msg);
            }
          })
    }

    componentDidMount(){
        Promise.all([
            cargarCatalogos('TIPOMOTIMP'),
            this.props.generar_LogAuditoriaIngresoForm('0303')
        ])
        .then(([result_motivo,]) => {
            let fechaProceso = getFechaProcesoPorModulo('03');
            this.setState(
                { array_motivo: result_motivo, fechaProceso: moment(fechaProceso,'DD/MM/YYYY')
            })
        })
        .catch(err => {
            console.log(err);
        });        
        this.props.cargar_ValoresIniciales();
    }
    
    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0303');
    }
    
    render(){
        const { handleSubmit, submitting } = this.props
        return(
            <ContenedorForm porc_ancho={73}>
            <HeaderForm>
                <TituloForm>Ajuste Pago Importacion</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <ContainerEdit>
                        <Row>
                            <div className='col-md-6'>
                                <Field
                                    label="Importación:"
                                    name="importacion"
                                    component={ FieldBusqEspecifica }
                                    loadOptions={this.getOptions_Importaciones.bind(this)}
                                    getItemEspecifico={this.getImportacion.bind(this)}
                                    textoBoton="Sel."
                                    icono="fa fa-check-circle-o"/>
                            </div>
                            <div className='col-md-3 col-md-offset-3'>
                                <br/>
                                <Label>Importación seleccionada: {+ this.state.codigo_importacion}</Label>
                            </div>                       
                        </Row>                        
                    </ContainerEdit>
                        <form onSubmit={handleSubmit(this.submit.bind(this))}>
                            <Row>
                                <div className='col-md-1'>
                                    <Field
                                        name="tipo_ajuste"
                                        component={ FieldSelect }
                                        label="Ajuste:"                                        
                                        options={this.state.tipo_ajuste}/>
                                </div>
                                <div className='col-md-2'>
                                    <Field
                                        name="motivo"
                                        component={ FieldSelect }
                                        label="Motivo:"
                                        options={this.state.array_motivo}/>
                                </div>
                                <div className='col-md-2'>
                                    <Field
                                        name="ValorFOB"
                                        type="number"
                                        component={ FieldGenerico }
                                        disabled={true}
                                        label="F.O.B:"/>                                
                                </div>
                                <div className='col-md-2'>
                                    {/* <Field
                                        name="fecha"
                                        component={ FieldDate }
                                        label="Fecha:"
                                        readOnly='true'
                                        placeholder="dd/mm/aaaa"/> */}
                                    <LabelForm margen_arriba='4' margen_abajo='7'>Fecha caja:</LabelForm>
                                    <PickerFecha fechaSeleccionada={this.state.fechaProceso}
                                        disabled={this.props.permiteCambioFProceso==='S'?false:true} func_onChange={(fecha)=>{this.setState({fechaProceso: fecha})}}/>
                                </div>
                                <div className='col-md-5'>
                                    <Field
                                        name="observacion"                                    
                                        component={ FieldGenerico }
                                        mayusculas={true}
                                        label="Observación:"/>                                
                                </div>                                
                            </Row>
                            <Row>
                                <div className='col-md-12'>
                                    <AgGridRender altura='100px' data={this.state.data_planpago_import} columnas={this.state.columnDefs_Planpago} 
                                    gridOptions={this.state.gridOptions_PlanPago} onGridReady={this.onGridPlanPago}/>                                                            
                                </div>
                            </Row>
                            <Row>
                                <div className='col-md-12'>
                                    <br/>
                                    <Label>Ajustes realizados en la importación:</Label>                                    
                                    <AgGridRender altura='150px' data={this.state.data_ajustes} columnas={this.state.columnDefs_Ajustes} gridOptions={this.state.gridOptions_Ajustes} onGridReady={this.onGridAjusteImport}/>                                                           
                                </div>
                            </Row>
                            <Row>                               
                                <div className='col-md-12'>                                    
                                    <div className="btn-group pull-right">                                    
                                        <button type="submit" className='btn btn-primary btn-sm' disabled={submitting}>
                                            <i className="fa fa-floppy-o fa-lg"></i> Guardar
                                        </button>
                                    </div>                                                                        
                                </div>
                            </Row>
                        </form>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const selector = formValueSelector('form_impor03');

FormImport03 = reduxForm({
    form: 'form_impor03', enableReinitialize: true, validate
})(FormImport03)

FormImport03 = connect( 
    state => ({
        initialValues: state.inicializacion_form.data,
        codigo_importacion: selector(state, 'importacion'),
        detalle_plan_pago: selector(state, 'plan_pago'),
        detalle_ajuste: selector(state, 'ncCredito'),
        tipo_ajuste: selector(state, 'tipo_ajuste'),
        IdRegAudit: state.sesion.valoresSesionForm.IdRegAudit, 
        permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
        diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias 

    }),
    { cargar_Ajuste_PlanPago_a_Editar: cargar_AjustePlanPago,
        cargar_ValoresIniciales, generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm }
)(FormImport03)

export default FormImport03;